import React, { useEffect, useState, useRef } from "react";
import { useLottie } from "lottie-react";

import { ErrorMessage } from "../../../components";

const VtrgJsonImg = ({ data, slot }) => {
  const [error, setError] = useState(null);

  let styles = data && data.style ? data.style : "";

  let currentAnimation;

  try {
    if (!error) {
      currentAnimation = JSON.parse(data.json);
    }
  } catch (error) {
    setError(error.message);
  }

  const wrapper = useRef();

  const options = {
    animationData: currentAnimation,
    renderer: "svg",
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const { View: animation } = useLottie(options);

  useEffect(() => {
    wrapper.current.setAttribute("style", styles);
  }, [wrapper, styles]);

  return (
    <div ref={wrapper} data-slot={slot}>
      {error ? (
        <div className="holder">
          <div className="content">
            <ErrorMessage
              text={`Анимация не отображается, потому что JSON-код содержит ошибки.`}
              message={error}
            />
          </div>
        </div>
      ) : (
        animation
      )}
    </div>
  );
};

export default VtrgJsonImg;
